module.exports = __webpack_public_path__ + "static/img/banner.ce818c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner.png
// module id = cxzu
// module chunks = 0